import { useGoodsBasic } from '../queries/useGoodsBasic';

export const useIsOnSale = () => {
  const { data: basic } = useGoodsBasic();

  return basic?.sale_type === 'ON_SALE';
};
